var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-live-list',{staticClass:"pt-live-list__withData"})}
var staticRenderFns = []

export { render, staticRenderFns }